import { Modal } from '@/components/ui/Modal';

interface TermsModalProps {
  open: boolean;
  onClose: () => void;
}

export function TermsModal({ open, onClose }: TermsModalProps) {
  return (
    <Modal open={open} onClose={onClose} title="Terms">
      <section className="privacy-section">
        <p>
          By playing Slime Pang at slimepang.com, you agree to these terms. If you do not agree,
          please stop using the site.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-service">
        <h3 id="terms-service">The service</h3>
        <p>
          Slime Pang is a free browser game. We may update, modify, or discontinue the game at any
          time without notice.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-ads">
        <h3 id="terms-ads">Advertising</h3>
        <p>
          Ads on this site are served by third-party advertising networks (GameMonetize and Google).
          We do not endorse, control, or take responsibility for the content of any advertisement.
          Use of any product or service linked from an ad is at your own risk and governed by the
          third party&rsquo;s terms.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-warranty">
        <h3 id="terms-warranty">No warranty</h3>
        <p>
          The game is provided &ldquo;as is&rdquo; and &ldquo;as available&rdquo; without warranties
          of any kind, either express or implied, including warranties of merchantability, fitness
          for a particular purpose, or non-infringement. We do not guarantee uninterrupted
          availability or that the game will be error-free.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-liability">
        <h3 id="terms-liability">Limitation of liability</h3>
        <p>
          To the maximum extent permitted by law, we are not liable for any indirect, incidental,
          consequential, or punitive damages arising out of your use of, or inability to use, the
          game &mdash; including damages from ad content, leaderboard outages, or lost progress.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-changes">
        <h3 id="terms-changes">Changes</h3>
        <p>
          We may update these terms from time to time. Continued use of the site after changes are
          posted constitutes acceptance.
        </p>
      </section>

      <section className="privacy-section" aria-labelledby="terms-contact">
        <h3 id="terms-contact">Contact</h3>
        <p>
          Questions:{' '}
          <a href="mailto:reimaginegamestudio@gmail.com">reimaginegamestudio@gmail.com</a>.
        </p>
      </section>
    </Modal>
  );
}
